import moment, {Moment} from "moment";

export class ADatabaseBackupRes {
    fileName!: string;
    sizeInMb!: number;
    _created!: any;

    get created(): any {
        return this._created;
    }

    set created(value: any) {
        this._created = moment(value);
    }
}